export default __webpack_public_path__ + "static/media/hotel.50b2da19.png";